import { SelectOptions } from "../select-options";
import { MapPinIcon } from "@/components/assets/icons";
import { useState } from "react";
import { AddressCustomFormUz } from "./select-address-custom-form-uz";
import { OptionType } from "../select";
import { useGetCustomAddressesForShipmentRequest } from "@/api/useGetCustomAddressesForShipmentRequest";

export default function SelectAddressCustomFlow({
  onSelect,
  selectedOption,
}: {
  onSelect: (selectedValue) => void;
  selectedOption: OptionType;
}) {
  const [showView, setView] = useState<"list" | "form">("list");
  const { data: customAddresses, isLoading: customAddressIsLoading } =
    useGetCustomAddressesForShipmentRequest();

  const addressOptions =
    customAddresses?.data?.data?.length > 0
      ? customAddresses?.data?.data?.map((address) => {
          const option = {
            id: address.addressId,
            mainText: `${address?.firstName} ${address?.lastName}`,
            secondaryText: address.streetName,
            icon: <MapPinIcon />,
          };
          return option;
        })
      : [];

  return showView === "list" ? (
    <SelectOptions
      options={addressOptions}
      onSelect={onSelect}
      additionalFormButtonText="Add new address"
      onAdditionalButtonClick={() => setView("form")}
      searchPlaceholder="Search for address"
      selectedOption={selectedOption}
    />
  ) : (
    <AddressCustomFormUz onShowList={() => setView("list")} />
  );
}
